<script>
import ListingModel from "@/views/Recruitment/Planning/Components/ListingModel.vue"

export default {
    name: "Plannings",
    components: {ListingModel},
}
</script>

<template>
    <ListingModel type="PLANNING"/>
</template>